import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maxCharacters',
  standalone: false
})
export class MaxCharactersPipe implements PipeTransform {
  /**
   * Transforms an array into a string in the format "item, item, item, and # more"
   *
   * @param value The array to transform
   * @param maxItems Maximum number of items to display before using "and # more"
   * @returns Formatted string
   */
  transform(value: string | string[], maxCharacters: number = 30): string | string[] {
    if (!value || !Array.isArray(value) || value.length === 0) {
      return value as string;
    }

    const valueLength = value.join(', ').length;
    if (valueLength <= maxCharacters) {
      return value;
    }

    return value.length + ' Items';
  }
}
